import { Component, OnInit } from '@angular/core';
import { LMSContentService } from 'lms-api';
import { Router } from '@angular/router';

@Component({
  selector: 'app-landing-cecenter',
  templateUrl: './landing-cecenter.component.html',
  styleUrls: ['./landing-cecenter.component.scss']
})
export class LandingCECenterComponent implements OnInit {

  constructor(public lmsContentService: LMSContentService, private router: Router) { }

  ngOnInit() {
    this.lmsContentService.GetContentBlock("CE Center Landing Page").subscribe(block => {
      if(block.trim() == "") {
        this.router.navigate(['/']);
      }
    });
  }

}
